// ----------------------------------------------------------------------

function path(root, sublink) {
    return `${root}${sublink}`;
}

const ROOTS_AUTH = '/auth';
const ROOTS_DASHBOARD = '';

// ----------------------------------------------------------------------

export const PATH_AUTH = {
    root: ROOTS_AUTH,
    login: path(ROOTS_AUTH, '/login'),
    operatorLogin: path(ROOTS_AUTH, '/operator-login'),
    register: path(ROOTS_AUTH, '/register'),
    loginUnprotected: path(ROOTS_AUTH, '/login-unprotected'),
    registerUnprotected: path(ROOTS_AUTH, '/register-unprotected'),
    verify: path(ROOTS_AUTH, '/verify'),
    resetPassword: path(ROOTS_AUTH, '/reset-password'),
    newPassword: path(ROOTS_AUTH, '/new-password'),
};

export const PATH_PAGE = {
    comingSoon: '/coming-soon',
    maintenance: '/maintenance',
};

export const PATH_DASHBOARD = {
    root: ROOTS_DASHBOARD,
    general: {
        app: path(ROOTS_DASHBOARD, '/home'),
        stationServices: path(ROOTS_DASHBOARD, '/stationServices'),
        new_invoice: path(ROOTS_DASHBOARD, '/home/newInvoice'),
        reports: path(ROOTS_DASHBOARD, '/reports'),
        invoices: path(ROOTS_DASHBOARD, '/invoices'),
        settings: path(ROOTS_DASHBOARD, '/settings'),
    },
    discounts: {
        root: path(ROOTS_DASHBOARD, '/discounts'),
        list: path(ROOTS_DASHBOARD, '/discounts/list'),
        new: path(ROOTS_DASHBOARD, '/discounts/new'),
        edit: (id) => path(ROOTS_DASHBOARD, `/discounts/${id}/edit`),
    },
    bus: {
        root: path(ROOTS_DASHBOARD, '/bus'),
        list: path(ROOTS_DASHBOARD, '/bus/list'),
        new: path(ROOTS_DASHBOARD, '/bus/new'),
        edit: (id) => path(ROOTS_DASHBOARD, `/bus/${id}/edit`),
    },
    priceList: {
        root: path(ROOTS_DASHBOARD, '/priceList'),
        list: path(ROOTS_DASHBOARD, '/priceList/list'),
        stationsList: path(ROOTS_DASHBOARD, '/priceList/stationsList'),
        new: path(ROOTS_DASHBOARD, '/priceList/new'),
        newStation: path(ROOTS_DASHBOARD, '/priceList/newStation'),
        stationsServicesList: path(ROOTS_DASHBOARD, '/priceList/stationsServicesList'),
        stationsServicesAdd: path(ROOTS_DASHBOARD, '/priceList/stationsServicesAdd'),
        edit: (id) => path(ROOTS_DASHBOARD, `/priceList/${id}/edit`),
        editStation: (id) => path(ROOTS_DASHBOARD, `/priceList/${id}/edit-station`),
        editStationService: (id) => path(ROOTS_DASHBOARD, `/priceList/${id}/edit-station-service`),
    },
    stationList: {
        root: path(ROOTS_DASHBOARD, '/stationList'),
        list: path(ROOTS_DASHBOARD, '/stationList/list'),
        new: path(ROOTS_DASHBOARD, '/stationList/new'),
        edit: (id) => path(ROOTS_DASHBOARD, `/stationList/${id}/edit`),
    },
    locationList: {
        root: path(ROOTS_DASHBOARD, '/locationList'),
        list: path(ROOTS_DASHBOARD, '/locationList/list'),
        new: path(ROOTS_DASHBOARD, '/locationList/new'),
        edit: (id) => path(ROOTS_DASHBOARD, `/locationList/${id}/edit`),
    },
    linesList: {
        root: path(ROOTS_DASHBOARD, '/linesList'),
        list: path(ROOTS_DASHBOARD, '/linesList/list'),
        new: path(ROOTS_DASHBOARD, '/linesList/new'),
        edit: (id) => path(ROOTS_DASHBOARD, `/linesList/${id.id}/edit`),
    },
    departuresList: {
        root: path(ROOTS_DASHBOARD, '/departuresList'),
        list: path(ROOTS_DASHBOARD, '/departuresList/list'),
        new: path(ROOTS_DASHBOARD, '/departuresList/new'),
        edit: (id) => path(ROOTS_DASHBOARD, `/departuresList/${id}/edit`),
    },
    timesList: {
        root: path(ROOTS_DASHBOARD, '/timesList'),
        list: path(ROOTS_DASHBOARD, '/timesList/list'),
        new: path(ROOTS_DASHBOARD, '/timesList/new'),
        edit: (id) => path(ROOTS_DASHBOARD, `/timesList/${id}/edit`),
    },
    monthlyTicketsList: {
        root: path(ROOTS_DASHBOARD, '/monthlyTicketsList'),
        list: path(ROOTS_DASHBOARD, '/monthlyTicketsList/list'),
        new: path(ROOTS_DASHBOARD, '/monthlyTicketsList/new'),
        edit: (id) => path(ROOTS_DASHBOARD, `/monthlyTicketsList/${id}/edit`),
    },
    customers: {
        root: path(ROOTS_DASHBOARD, '/customers'),
        list: path(ROOTS_DASHBOARD, '/customers/list'),
        new: path(ROOTS_DASHBOARD, '/customers/new'),
        edit: (id) => path(ROOTS_DASHBOARD, `/customers/${id.uid}/edit`),
    },
    carriers: {
        root: path(ROOTS_DASHBOARD, '/carriers'),
        list: path(ROOTS_DASHBOARD, '/carriers/list'),
        new: path(ROOTS_DASHBOARD, '/carriers/new'),
        edit: (id) => path(ROOTS_DASHBOARD, `/carriers/${id.uid}/edit`),
    },
    insurance: {
        root: path(ROOTS_DASHBOARD, '/insurance'),
        list: path(ROOTS_DASHBOARD, '/insurance/list'),
        new: path(ROOTS_DASHBOARD, '/insurance/new'),
        edit: (id) => path(ROOTS_DASHBOARD, `/insurance/${id.uid}/edit`),
    },
};

